import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { MessageFolderListStateService } from '@modules/messages/services/message-folder-list-state.service';
import { MessageFoldersService } from '@modules/messages/services/message-folders.service';
import { MessageFolder } from '@modules/messages/types/message-folder';
import { MessageFoldersFilters } from '@modules/messages/types/message-folders-filters';
import { MessageFoldersListState } from '@modules/messages/types/message-folders-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-mail-folders-section',
  templateUrl: './mail-folders-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...MessageFolderListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeMailFoldersSectionComponent
  extends KnowledgeStitchSectionComponent<MessageFolder, MessageFoldersFilters>
  implements OnInit
{
  protected readonly listStateService = inject(MessageFolderListStateService, { self: true });
  protected readonly stitchService = inject(MessageFoldersService);

  public override ngOnInit(): void {
    this.state = new MessageFoldersFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: MessageFoldersListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new MessageFoldersFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
